import { CommonOfficeLocationJsonResponse, GetAllClientsJsonResponse, GetAllUserGroupsJsonResponse, GetAllUsersJsonResponse } from "../../common/model/suite/jsonResponse";
import { createCommonJsonResponse } from "../objectTypeConstants";

/* CLIENT MANAGEMENT */
export const getAllClientsJsonResponse: GetAllClientsJsonResponse = {
    ...createCommonJsonResponse(200),
    data : [{
        uniqueId: 0,
        clientId: "string",
        clientDetails: {
            name: "string",
            emailAddress: "string",
            mobileNumber: "string",
            countryCode: "string",
            dob: "2024-12-02T12:14:42.374Z",
            ssn_or_ein: "string"
        },
        spouseDetails: {
            name: "string",
            emailAddress: "string",
            mobileNumber: "string",
            countryCode: "string",
            dob: "2024-12-02T12:14:42.374Z",
            ssn_or_ein: "string"
        },
        type: 0,
        ero: 0,
        mfj: false,
        locationId: 0
    }],
}

/* OFFICE LOCATION */
export const commonOfficeLocationJsonResponse: CommonOfficeLocationJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        locationId: 0,
        isPrimary: false,
        name: "string",
        countryCode: "string",
        phone: "string",
        address1: "string",
        address2: "string",
        city: "string",
        zip: "string",
        fax: "string",
        website: "string",
        state: 0
    }]
}

/* USER MANAGEMENT */
export const getAllUsersJsonResponse: GetAllUsersJsonResponse = {
    ...createCommonJsonResponse(200),
   data:[{
        userId: 0,
        firstName: "string",
        lastName: "string",
        emailAddress: "string",
        phone: "string",
        extension: "string",
        fax: "string",
        mobileNumber: "string",
        countryCode: "string",
        ptin: "string",
        isMFAEnabled: false,
        groups: [{
            groupId: "string",
            groupName: "string"
        }],
        officeLocations: [{
            locationId: "string",
            locationName: "string",
            isPrimary: false
        }]
    }],
}

export const getAllUserGroupsJsonResponse: GetAllUserGroupsJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        groupId: 0,
        groupName: "string",
        groupDescription: "string",
        isDefault: false,
        roles: [{
            roleId: 0,
            roleName: "string",
            products: [
                0
            ]
        }]
    }],
}